var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPkgDelay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 2,
    fill: "#0065D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.9167C14.0169 29.9167 9.16669 25.253 9.16669 19.5C9.16669 13.747 14.0169 9.08333 20 9.08333C25.9831 9.08333 30.8334 13.747 30.8334 19.5C30.8268 25.2503 25.9804 29.9103 20 29.9167ZM20 11.1667C15.2136 11.1667 11.3334 14.8976 11.3334 19.5C11.3334 24.1024 15.2136 27.8333 20 27.8333C24.7865 27.8333 28.6667 24.1024 28.6667 19.5C28.6613 14.8998 24.7843 11.1718 20 11.1667ZM25.4167 20.5417H18.9167V14.2917H21.0834V18.4583H25.4167V20.5417Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPkgDelay);
export default __webpack_public_path__ + "static/media/pkgDelay.355440fdf2dd1fe546a8271903c7e69a.svg";
export { ForwardRef as ReactComponent };